var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { LucidDevToolsContext } from './LucidDevToolsContext';
export const LucidDevToolsProvider = ({ children, }) => {
    _react_refresh_temp_2();
    const [isLucidDevToolsWidgetOpen, setIsLucidDevToolsWidgetOpen] = useState(false);
    const openLucidDevToolsWidget = useCallback(() => setIsLucidDevToolsWidgetOpen(true), []);
    const closeLucidDevToolsWidget = useCallback(() => setIsLucidDevToolsWidgetOpen(false), []);
    const toggleLucidDevToolsWidget = useCallback(() => setIsLucidDevToolsWidgetOpen((isOpen) => !isOpen), []);
    const value = useMemo(() => {
        return {
            isLucidDevToolsWidgetOpen,
            openLucidDevToolsWidget,
            closeLucidDevToolsWidget,
            toggleLucidDevToolsWidget,
        };
    }, [
        isLucidDevToolsWidgetOpen,
        openLucidDevToolsWidget,
        closeLucidDevToolsWidget,
        toggleLucidDevToolsWidget,
    ]);
    return (_jsx(LucidDevToolsContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = LucidDevToolsProvider;
$RefreshReg$(_react_refresh_temp_1, "LucidDevToolsProvider");
_react_refresh_temp_2(LucidDevToolsProvider, "zldOYN3SVLP55V/BmYQ3pBCVufs=");
